import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField
} from 'semantic-ui-react'

const CardConsultOrderDetailUX = (props: any) => {
    return(
      <div
        id="CardConsultOrderDetailUX-div-0"
        style={{padding: "15px"}}>
        <div
          id="CardConsultOrderDetailUX-div-1"
          style={{display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 0px 20px"}}>
          
          <div
            id="CardConsultOrderDetailUX-div-5"
            style={{color: "#0D71BB",  fontSize: "18px", fontWeight: "bold"}}>
            {props.languageUX === "en" ? "Consultation submission list" : "รายการส่ง Consult"}
          </div>
          <div
            id="CardConsultOrderDetailUX-div-6">
            {props.labelStatus}
          </div>
        </div>
        <div
          id="CardConsultOrderDetailUX-div-2"
          style={{border: "1px solid #ECECEC", position: "relative", padding: "20px 10px 16px"}}>
          
          <div
            id="CardConsultOrderDetailUX-div-7"
            style={{position: "absolute",  fontWeight: "bold", color: "#0D71BB", padding: "10px", backgroundColor: "white",  bottom: "60px",  left: "58px", transform: "translate(-50%, -50%)",   flexWrap: "nowrap",}}>
            {props.languageUX === "en" ? "Consultant:" : "ผู้ส่งปรึกษา:"}
          </div>
          <div
            className="ui form"
            id="CardConsultOrderDetailUX-div-8">
            
            <FormGroup
              id="CardConsultOrderDetailUX-FormGroup-9"
              inline={true}>
              <FormField
                id="CardConsultOrderDetailUX-FormField-11"
                inline={true}
                width={8}>
                <div
                  id="CardConsultOrderDetailUX-div-15">
                  {props.languageUX === "en" ? "Physician:" : "แพทย์:"}
                </div>
                <div
                  id="CardConsultOrderDetailUX-div-16">
                  {props.orderDoctor}
                </div>
              </FormField>
              <FormField
                id="CardConsultOrderDetailUX-FormField-12"
                width={8}>
                <div
                  id="CardConsultOrderDetailUX-div-17">
                  {props.languageUX === "en" ? "Department:" : "แผนก:"}
                </div>
                <div
                  id="CardConsultOrderDetailUX-div-18">
                  {props.orderDivision}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardConsultOrderDetailUX-FormGroup-10"
              inline="true">
              <FormField
                id="CardConsultOrderDetailUX-FormField-13"
                width={8}>
                <div
                  id="CardConsultOrderDetailUX-div-19">
                  {props.languageUX === "en" ? "Consultation submission date:" : "วันที่ส่งปรึกษา:"}
                </div>
                <div
                  id="CardConsultOrderDetailUX-div-20">
                  {props.orderDateTime}
                </div>
              </FormField>
              <FormField
                id="CardConsultOrderDetailUX-FormField-14"
                width={8}>
                <div
                  id="CardConsultOrderDetailUX-div-21">
                  {props.languageUX === "en" ? "Encounter No." : "Encounter No."}
                </div>
                <div
                  id="CardConsultOrderDetailUX-div-22">
                  {props.orderEncounterNo}
                </div>
              </FormField>
            </FormGroup>
          </div>
        </div>
        <div
          id="CardConsultOrderDetailUX-div-40"
          style={{border: "1px solid #ECECEC", position: "relative", padding: "20px 10px 16px", marginTop: "30px"}}>
          
          <div
            id="CardConsultOrderDetailUX-div-41"
            style={{position: "absolute",  fontWeight: "bold", color: "#0D71BB", padding: "10px", backgroundColor: "white",  bottom: "100px",  left: "100px", transform: "translate(-50%, -50%)",   flexWrap: "nowrap",}}>
            {props.languageUX === "en" ? "Consultation submission details:" : "รายละเอียดการส่งปรึกษา:"}
          </div>
          <div
            id="CardConsultOrderDetailUX-div-42"
            style={{textAlign: "left", maxHeight: "100px", height: "100px", overflow: "auto", whiteSpace: "pre-line"}}>
            {props.consultedNote}
          </div>
        </div>
        <div
          id="CardConsultOrderDetailUX-div-23"
          style={{border: "1px solid #ECECEC", position: "relative", padding: "20px 10px 16px", marginTop: "30px"}}>
          
          <div
            id="CardConsultOrderDetailUX-div-24"
            style={{position: "absolute",  fontWeight: "bold", color: "#0D71BB", padding: "10px", backgroundColor: "white",  bottom: "60px",  left: "58px", transform: "translate(-50%, -50%)",   flexWrap: "nowrap",}}>
            {props.languageUX === "en" ? "Consultant:" : "ผู้รับปรึกษา:"}
          </div>
          <div
            className="ui form"
            id="CardConsultOrderDetailUX-div-25">
            
            <FormGroup
              id="CardConsultOrderDetailUX-FormGroup-26"
              inline={true}>
              <FormField
                id="CardConsultOrderDetailUX-FormField-27"
                inline={true}
                width={8}>
                <div
                  id="CardConsultOrderDetailUX-div-28">
                  {props.languageUX === "en" ? "Physician:" : "แพทย์:"}
                </div>
                <div
                  id="CardConsultOrderDetailUX-div-29">
                  {props.consultedDoctor}
                </div>
              </FormField>
              <FormField
                id="CardConsultOrderDetailUX-FormField-30"
                width={8}>
                <div
                  id="CardConsultOrderDetailUX-div-31">
                  {props.languageUX === "en" ? "Department:" : "แผนก:"}
                </div>
                <div
                  id="CardConsultOrderDetailUX-div-32">
                  {props.consultedDivision}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardConsultOrderDetailUX-FormGroup-33"
              inline="true">
              <FormField
                id="CardConsultOrderDetailUX-FormField-34"
                width={8}>
                <div
                  id="CardConsultOrderDetailUX-div-35">
                  {props.languageUX === "en" ? "Consultation appointment date:" : "วันที่นัดส่งปรึกษา:"}
                </div>
                <div
                  id="CardConsultOrderDetailUX-div-36">
                  {props.consultedDateTime}
                </div>
              </FormField>
              <FormField
                id="CardConsultOrderDetailUX-FormField-37"
                width={8}>
                <div
                  id="CardConsultOrderDetailUX-div-38">
                  {props.languageUX === "en" ? "Encounter No." : "Encounter No."}
                </div>
                <div
                  id="CardConsultOrderDetailUX-div-39">
                  {props.consultedEncounterNo}
                </div>
              </FormField>
            </FormGroup>
          </div>
        </div>
        <div
          id="CardConsultOrderDetailUX-div-43"
          style={{padding: "15px 10px", display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
          {props.actionButton}
        </div>
      </div>
    )
}


export default CardConsultOrderDetailUX

export const screenPropsDefault = {"language":"EN"}

/* Date Time : Thu Nov 20 2025 07:17:10 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"15px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\", padding: \"10px 0px 20px\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{border: \"1px solid #ECECEC\", position: \"relative\", padding: \"20px 10px 16px\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการส่ง Consult",
          "valueEN": "Consultation submission list"
        },
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-div-5"
        },
        "style": {
          "type": "code",
          "value": "{color: \"#0D71BB\",  fontSize: \"18px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.labelStatus"
        },
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-div-6"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ส่งปรึกษา:",
          "valueEN": "Consultant:"
        },
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-div-7"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\",  fontWeight: \"bold\", color: \"#0D71BB\", padding: \"10px\", backgroundColor: \"white\",  bottom: \"60px\",  left: \"58px\", transform: \"translate(-50%, -50%)\",   flexWrap: \"nowrap\",}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-div-8"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormGroup",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-FormGroup-9"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormGroup",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-FormGroup-10"
        },
        "inline": {
          "type": "value",
          "value": "true"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "FormField",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-FormField-11"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-FormField-12"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "FormField",
      "parent": 10,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-FormField-13"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "FormField",
      "parent": 10,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-FormField-14"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": "แพทย์:",
          "valueEN": "Physician:"
        },
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-div-15"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "code",
          "value": "props.orderDoctor"
        },
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-div-16"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนก:",
          "valueEN": "Department:"
        },
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-div-17"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "code",
          "value": "props.orderDivision"
        },
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-div-18"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่ส่งปรึกษา:",
          "valueEN": "Consultation submission date:"
        },
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-div-19"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "div",
      "parent": 13,
      "props": {
        "children": {
          "type": "code",
          "value": "props.orderDateTime"
        },
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-div-20"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": "Encounter No.",
          "valueEN": "Encounter No."
        },
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-div-21"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "code",
          "value": "props.orderEncounterNo"
        },
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-div-22"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-div-23"
        },
        "style": {
          "type": "code",
          "value": "{border: \"1px solid #ECECEC\", position: \"relative\", padding: \"20px 10px 16px\", marginTop: \"30px\"}"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 23,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้รับปรึกษา:",
          "valueEN": "Consultant:"
        },
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-div-24"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\",  fontWeight: \"bold\", color: \"#0D71BB\", padding: \"10px\", backgroundColor: \"white\",  bottom: \"60px\",  left: \"58px\", transform: \"translate(-50%, -50%)\",   flexWrap: \"nowrap\",}"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "div",
      "parent": 23,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-div-25"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "FormGroup",
      "parent": 25,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-FormGroup-26"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "FormField",
      "parent": 26,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-FormField-27"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "div",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": "แพทย์:",
          "valueEN": "Physician:"
        },
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-div-28"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "div",
      "parent": 27,
      "props": {
        "children": {
          "type": "code",
          "value": "props.consultedDoctor"
        },
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-div-29"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "FormField",
      "parent": 26,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-FormField-30"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "div",
      "parent": 30,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนก:",
          "valueEN": "Department:"
        },
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-div-31"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "div",
      "parent": 30,
      "props": {
        "children": {
          "type": "code",
          "value": "props.consultedDivision"
        },
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-div-32"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "FormGroup",
      "parent": 25,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-FormGroup-33"
        },
        "inline": {
          "type": "value",
          "value": "true"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "FormField",
      "parent": 33,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-FormField-34"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "div",
      "parent": 34,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่นัดส่งปรึกษา:",
          "valueEN": "Consultation appointment date:"
        },
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-div-35"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": null,
      "id": 36,
      "name": "div",
      "parent": 34,
      "props": {
        "children": {
          "type": "code",
          "value": "props.consultedDateTime"
        },
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-div-36"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "FormField",
      "parent": 33,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-FormField-37"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "div",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": "Encounter No.",
          "valueEN": "Encounter No."
        },
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-div-38"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "div",
      "parent": 37,
      "props": {
        "children": {
          "type": "code",
          "value": "props.consultedEncounterNo"
        },
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-div-39"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-div-40"
        },
        "style": {
          "type": "code",
          "value": "{border: \"1px solid #ECECEC\", position: \"relative\", padding: \"20px 10px 16px\", marginTop: \"30px\"}"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "div",
      "parent": 40,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดการส่งปรึกษา:",
          "valueEN": "Consultation submission details:"
        },
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-div-41"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\",  fontWeight: \"bold\", color: \"#0D71BB\", padding: \"10px\", backgroundColor: \"white\",  bottom: \"100px\",  left: \"100px\", transform: \"translate(-50%, -50%)\",   flexWrap: \"nowrap\",}"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "div",
      "parent": 40,
      "props": {
        "children": {
          "type": "code",
          "value": "props.consultedNote"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-div-42"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"left\", maxHeight: \"100px\", height: \"100px\", overflow: \"auto\", whiteSpace: \"pre-line\"}"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.actionButton"
        },
        "id": {
          "type": "value",
          "value": "CardConsultOrderDetailUX-div-43"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"15px 10px\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\"}"
        }
      },
      "seq": 43,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardConsultOrderDetailUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "EN"
  },
  "width": 80
}

*********************************************************************************** */
